let headings = {}
for (let num = 1; num <= 6; num++) {
  headings[`h${num}`] = { variant: `styles.h${num}` }
}

export default {
  root: {
    fontFamily: "body",
    fontSize: 1,
    fontWeight: "body",
    lineHeight: "body",
  },


  Schaubild:{

  },

  SourcedImage: {
    variant: "styles.img",
    mx: "auto",
  },
  SourcedContent: {

    ...headings,

    p: {
      variant: "styles.p",
      color: "text",
      wordBreak: "break-word",

    },
    // <p class="small"> → styles.p.small
    "p.small": {
      variant: "styles.p.small",
    },
    span:{
    },
    h1: {
      variant: "styles.h1",
      // fontSize: [5,5,6],
      color:`primary`,
      wordBreak: "break-word",
    },
    h2: {
      variant: "styles.h2",
      // fontSize: [3,3,5],
      //color:`primary`
    },

    h3: {
      variant: "styles.h3",
      color:`primary`
    },
    h4: {
      variant: "styles.h4",
      color:`primary`
    },
    a: {
      variant: "underline",
    },
    // Buttons from the Drupal editor reuse the variants from theme.buttons:
    // <button> or <a class="button"> → light, plus modifier classes
    "button, .button": {
      variant: "buttons.light",
      display: `inline-block`,
    },
    ".button--small": {
      variant: "buttons.small",
    },
    ".button--invert": {
      variant: "buttons.lightInvert",
    },
        ".button--dark": {
      variant: "buttons.dark",
    },
    ul: {
      variant: "styles.ul",
    },
    li: {
      variant: "styles.li",
    },
    ".gallery": {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      ml: "-23px",
      mr: "-23px",
    },

    ".gallery-item": {
      mx: 3,
      my: 3,
    },
  },
  CategoryItem: {
    textDecoration: `none`,
    color: `text`,
    "&:hover": {
      color: "primary",
    },
    "&:not(:last-child)": {
      mr: 1,
    },
    "&:not(:last-child):after": {
      content: '" ~ "',
      ml: 1,
    },
  },
}